import { useState } from 'react';
import { colors } from '~/layout';
import { STATUS } from '~/store/actions/actionTypes';

export default function useStatus() {
  const [statusColor, setStatusColor] = useState('red');
  const [statusDescription, setStatusDescription] = useState('Unavailable');

  function setStatus(status) {
    setStatusDescription(status);
    switch (status) {
      case STATUS.BUSY:
        setStatusColor(colors.yellow01);
        break;
      case STATUS.AVAILABLE:
        setStatusColor(colors.green03);
        break;
      case STATUS.UNAVAILABLE:
        setStatusColor(colors.red03);
        break;
      default:
        setStatusColor(colors.red03);
        break;
    }
  }

  return [{ statusDescription, statusColor }, setStatus];
}
